export default {
  setLoading (state, loading) {
    state.loading = loading
  },
  setScaleSummaryLoading (state, loading) {
    state.scaleSummaryLoading = loading
  }
}
